import {
  FormControl,
  FormErrorMessage,
  Input,
  InputGroup,
  InputLeftElement,
  Text,
} from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';

import { DonationField, RegularExpressions } from '../../constants';
import { getError, sanitizeOtherAmount } from '../../utils';
import { FormErrors } from '../../types';

export interface DonationOtherAmountProps {
  isActive: boolean;
  onChange?: (amount: string) => void;
  onFocus: () => void;
  otherLevelId?: number;
  value?: string;
}

export const DonationOtherAmount = ({
  onChange,
  isActive,
  onFocus,
}: DonationOtherAmountProps) => {
  const { register, formState, trigger, setValue, watch } = useFormContext();

  const { errors }: { errors: FormErrors } = formState;

  return (
    <FormControl
      isInvalid={
        isActive && !!getError(DonationField.donationOtherAmount, errors)
      }
    >
      <InputGroup>
        <InputLeftElement w="max-content" px={3}>
          <Text as="span" fontSize={17} color="brand.monochromatic.700">
            Other:{' '}
            <Text as="span" fontSize={18} color="brand.secondary.swatch4">
              $
            </Text>
          </Text>
        </InputLeftElement>

        <Input
          {...register(DonationField.donationOtherAmount)}
          aria-label={DonationField.donationOtherAmount}
          // Color and Border-Color are set manually to match SJO and do not follow design guide standards
          color="brand.secondary.swatch4 !important"
          _invalid={{ borderColor: 'brand.monochromatic.200' }}
          paddingLeft={76}
          defaultValue={watch(DonationField.donationOtherAmount)}
          maxLength={10}
          pattern={RegularExpressions.isValidOtherAmount}
          inputMode="decimal"
          type="text"
          onBlurCapture={(e) => {
            const { value: val } = e.currentTarget;
            const cleaned = sanitizeOtherAmount(val);
            setValue(DonationField.donationOtherAmount, cleaned);
            setValue(DonationField.donationAmount, cleaned);
            onChange?.(cleaned);
          }}
          onFocus={() => {
            onFocus();
            setValue(DonationField.donationAmount, 0);
          }}
          /* Standard form validation is onBlur
           * We need an override for other donation.
           * Trigger a validation and update the form value
           */
          onChange={(e) => {
            const { value: val } = e.currentTarget;
            setValue(DonationField.donationOtherAmount, val);
            setValue(DonationField.donationAmount, val);
            trigger(DonationField.donationOtherAmount);
            onChange?.(val);
          }}
          id="other-amt"
        />
      </InputGroup>
      <FormErrorMessage>
        {getError(DonationField.donationOtherAmount, errors)}
      </FormErrorMessage>
    </FormControl>
  );
};
